// src/clubData.js
// Full Irish GAA club list organised by county
// Dublin & Leinster: complete as of June 2025
// Munster, Connacht, Ulster: structure in place, clubs to be added
// To add clubs: append to the relevant county array and push to GitHub

export const ALL_COUNTIES = [
  'Antrim', 'Armagh', 'Carlow', 'Cavan', 'Clare', 'Cork',
  'Derry', 'Donegal', 'Down', 'Dublin', 'Fermanagh', 'Galway',
  'Kerry', 'Kildare', 'Kilkenny', 'Laois', 'Leitrim', 'Limerick',
  'Longford', 'Louth', 'Mayo', 'Meath', 'Monaghan', 'Offaly',
  'Roscommon', 'Sligo', 'Tipperary', 'Tyrone', 'Waterford',
  'Westmeath', 'Wexford', 'Wicklow'
]

export const IRISH_GAA_CLUBS = {

  // ── LEINSTER ─────────────────────────────────────────────────────────────

  'Carlow': [
    'Bagenalstown Gaels', 'Ballinabranna', 'Ballinkillen', 'Ballon',
    'Burren Rangers', 'Carlow Town', 'Clonmore', 'Éire Óg',
    "Erin's Own", 'Fenagh', 'Fighting Cocks', 'Grange',
    'Kildavin Clonegal', 'Kilbride', 'Leighlinbridge', 'Milford',
    'Mount Leinster Rangers', 'Michael Davitts', 'Naomh Bríd',
    'Naomh Eoin', "O'Hanrahan's", 'Old Leighlin', 'Palatine',
    'Rathvilly', 'St Andrews', 'St Mullins', 'St Patricks', 'Tinryland'
  ],

  'Dublin': [
    'Ballinteer St Johns', 'Ballyboden St Endas', 'Ballyboughal',
    'Ballyfermot Gaels', 'Ballymun Kickhams', 'Beann Eadair',
    'Cabinteely', 'Castleknock', 'Civil Service', 'Clann Mhuire',
    'Clanna Gael Fontenoy', 'Clontarf', 'Commercials',
    'Craobh Chiarain', 'Croi Ro Naofa', 'Crumlin', 'Cuala',
    'Erin Go Bragh', 'Erins Isle', 'Faughs', 'Fingal Ravens',
    'Fingallians', 'Foxrock Cabinteely', 'Garda Westmanstown Gaels',
    'Garristown', 'Geraldine P Moran', 'Good Counsel Liffey Gaels',
    'Innisfails', 'Kevins', 'Kilmacud Crokes', 'Lucan Sarsfields',
    'Man O War', 'Na Fianna', 'Na Gaeil Aeracha', 'Na Gaeil Óga',
    'Naomh Barrog', 'Naomh Fionnbarra', 'Naomh Mearnog', 'Naomh Olaf',
    'O Dwyers', 'O Tooles', 'Parnells', 'Portobello', 'Raheny',
    'Ranelagh Gaels', 'Robert Emmets', 'Round Towers Clondalkin',
    'Round Towers Lusk', 'Skerries Harps', 'Shankill Stars',
    'St Annes', 'St Brendans', 'St Brigids', 'St Finians Swords',
    'St Judes', 'St Kevin Killians', 'St Marks', 'St Marys Saggart',
    'St Maurs', 'St Oliver Plunkett ER', 'St Patricks Donabate',
    'St Patricks Palmerstown', 'St Peters', 'St Sylvesters',
    'St Vincents', 'Templeogue Synge Street', 'Thomas Davis',
    'Trinity Gaels', 'Wanderers', 'Whitehall Colmcille'
  ],

  'Kildare': [
    'Athy', 'Ballymore Eustace', 'Caragh', 'Castledermot',
    'Celbridge', 'Clane', 'Confey', 'Coill Dubh', 'Clogherinkoe',
    'Eadestown', 'Johnstownbridge', 'Kill', 'Kildare', 'Kilcock',
    'Kilcullen', 'Kildarton', 'Leixlip', 'Maynooth', 'Monasterevin',
    'Moorefield', 'Naas', 'Newbridge', 'Nurney', 'Rathangan',
    'Rheban', 'Robertstown', 'Sallins', 'Sarsfields', 'Straffan',
    'Two Mile House', 'Timahoe', 'Wicklow GAA'
  ],

  'Kilkenny': [
    'Bennettsbridge', 'Blacks and Whites', 'Booterstown', 'Carrickshock',
    'Clara', 'Cloneen', 'Danesfort', 'Dicksboro', 'Dunnamaggin',
    'Erins Own', 'Fenians', 'Glenmore', 'Graigue Ballycallan',
    'James Stephens', 'John Lockes', 'Johnstown', 'Kilkenny CBS',
    'Mooncoin', 'Mullinavat', 'Naomh Eoin', 'O Loughlin Gaels',
    'Piltown', 'Rower Inistioge', 'St Brendans', 'St Lachtains',
    'St Martins', 'St Patricks', 'Thomastown', 'Tullaroan',
    'Tullogher Rosbercon', 'Urlingford', 'Young Irelands'
  ],

  'Laois': [
    'Abbeyleix', 'Annanough', 'Arles Kilcruise', 'Arles Killeen',
    'Ballyfin', 'Ballinakill', 'Ballyroan', 'Barrowhouse',
    'Camross', 'Castletown', 'Clonaslee', 'Colt',
    'Courtwood', 'Crettyard', 'Emo', 'Graiguecullen',
    'Killeshin', 'Mountmellick', 'Mountrath', 'Naomh Eoin',
    'O Moore', 'Portarlington', 'Portlaoise', 'Raheen',
    'Rosenallis', 'Shanahoe', 'Slieve Bloom', 'St Brigids',
    'St Josephs', 'Stradbally', 'The Heath', 'Timahoe',
    'Trumera', 'Wolfhill'
  ],

  'Longford': [
    'Abbeylara', 'Aughnacliffe', 'Ballymahon', 'Carrickedmond',
    'Cashel', 'Clonguish', 'Colmcille', 'Dromard',
    'Fr Manning Gaels', 'Granard', 'Killashee', 'Legan Sarsfields',
    'Longford Slashers', 'Mostrim', 'Mullinalaghta', 'Naomh Eoin',
    'Newtowncashel', 'Rathcline', 'St Brigids', 'Scrabby',
    'Sean Connolly'
  ],

  'Louth': [
    'Ardee St Marys', 'Blackrock', 'Clan na Gael', 'Cooley Kickhams',
    'Cuchulainn Gaels', 'Dreadnots', 'Dundalk Gaels', 'Dundalk Young Irelands',
    'Geraldines', 'Glyde Rangers', 'Hunterstown Rovers', 'John Mitchels',
    'Kilkerley Emmets', 'Lannleire', 'Mattock Rangers', 'Na Piarsaigh',
    'Naomh Fionnbarra', 'Newtown Blues', 'O Raghallaighs',
    'Ollie Brennan Gaels', 'Roche Emmets', 'Sean McDermotts',
    'St Brides', 'St Fechins', 'St Josephs', 'St Mochtas',
    'St Nicholas', 'St Patricks'
  ],

  'Meath': [
    'Ballinabrackey', 'Ballivor', 'Carnaross', 'Clann na nGael',
    'Clonard', 'Curraha', 'Donaghmore Ashbourne', 'Drumbaragh',
    'Dunderry', 'Dunshaughlin', "Erin's Isle", 'Éire Óg',
    'Gaeil Colmcille', 'Inny Gaels', 'Kilmainhamwood', 'Kilmessan', 'Kiltale',
    'Longwood', 'Moynalvey', 'Na Fianna', 'Navan O Mahonys',
    'Nobber', 'Oldcastle', 'Pairc Tailteann', 'Rathkenny',
    'Ratoath', 'Seneschalstown', 'Simonstown Gaels', 'Skryne',
    'Slane', 'St Colmcilles', 'St Marys Ardee', 'St Michaels',
    'St Patricks Trim', 'St Peters', 'St Ultan\'s', 'Summerhill',
    'Syddan', 'Trim', 'Walterstown', 'Wolfe Tones'
  ],

  'Offaly': [
    'Birr', 'Bracknagh', 'Clonbullogue', 'Clodiagh Gaels',
    'Daingean', 'Drumcullen', 'Edenderry', 'Ferbane',
    'Gracefield', 'Kilclonfert', 'Kilcormac Killoughey', 'Kinnitty',
    'Lusmagh', 'Naomh Ciaran', 'Pallaskenry', 'Raheen',
    'Rhode', 'Shamrocks', 'Shinrone', 'Simonstown Gaels',
    'St Brigids', 'St Faithleach\'s', 'St Rynaghs', 'Tullamore',
    'Walsh Island'
  ],

  'Westmeath': [
    'Athlone', 'Ballinagore', 'Ballymore', 'Castlepollard',
    'Castletown Geoghegan', 'Clara', 'Clonard', 'Coralstown Kinnegad',
    'Delvin', 'Drumraney', 'Garrycastle', 'Horseleap Streamstown',
    'Kilbeggan Shamrocks', 'Killucan', 'Lough Sheever', 'Moate All Whites',
    'Moate', 'Multyfarnham', 'Naomh Ciarain', 'St Loman\'s',
    'St Mary\'s Rochfortbridge', 'Tang', 'Tyrrellspass', 'Walshestown'
  ],

  'Wexford': [
    'Adamstown', 'Ballyhogue', 'Bannow Ballymitty', 'Bunclody',
    'Cloughbawn', 'Crossabeg Ballymurn', 'Davidstown Courtnacuddy',
    'Duffry Rovers', 'Faythe Harriers', 'Ferns St Aidans',
    'Glynn Barntown', 'Gorey', 'Horeswood', 'Kilanerin',
    'Kilmore', 'Naomh Eanna', 'New Ross', 'Oylegate Glenbrien',
    'Rapparees', 'Rathgarogue Cushinstown', 'Shelmaliers',
    'St Annes', 'St James Ramsgrange', 'St Josephs Piercestown',
    'St Martins', 'St Patricks', 'Taghmon Camross', 'Enniscorthy'
  ],

  'Wicklow': [
    'Annacurra', 'Arklow Geraldines Ballymoney', 'Avoca',
    'Baltinglass', 'Blessington', 'Bray Emmets', 'Carnew Emmets',
    'Donard Glen', 'Dunlavin', 'Éire Óg', 'Glenealy',
    'Hollywood', 'Kilcoole', 'Kiltegan', 'Knockananna',
    'Laragh United', 'Newtown', 'Rathnew', 'Roundwood',
    'St Patricks', 'St Kevins', 'St Mantan\'s', 'Tinahely',
    'Wicklow'
  ],

  // ── MUNSTER ──────────────────────────────────────────────────────────────

  'Clare': [
    'Ballyea', 'Bodyke', 'Broadford', 'Clarecastle', 'Clondegad', 'Clonmoney',
    'Corofin', 'Cratloe', 'Crusheen', 'Doonbeg', 'Éire Óg', 'Ennistymon',
    'Feakle', 'Fergus Rovers', 'Fifemiletown', 'Inagh-Kilnamona', 'Kildysart',
    'Kilkee', 'Kilkishen', 'Killaloe', 'Killanena', 'Kilmihil', 'Kilmurry',
    'Kilmurry-Ibrickane', 'Kilfenora', 'Kilrush', 'Lissycasey', 'Miltown Malbay',
    'Meelick', 'Naomh Eoin', 'Newmarket-on-Fergus', 'O\'Callaghan\'s Mills',
    'Ogonnelloe', 'Parteen', 'Quilty', 'Scariff', 'Shannon Gaels', 'Sixmilebridge',
    'Smithstown', 'St Breckan\'s', 'St Flannan\'s', 'St Joseph\'s Doora-Barefield',
    'St Joseph\'s Miltown', 'St Patrick\'s Kiltenanlea', 'Tulla', 'Wolfe Tones',
  ],
  'Cork': [
    'Aghabullogue', 'Aghada', 'Aghinagh', 'Ballinascarthy', 'Ballincollig',
    'Ballinhassig', 'Ballydesmond', 'Ballygiblin', 'Ballyhea', 'Ballylanders',
    'Ballymartle', 'Ballyvourney', 'Bantry Blues', 'Bishopstown', 'Blackrock',
    'Blarney', 'Bride Rovers', 'Carbery Rangers', 'Carrigaline', 'Carrigtwohill',
    'Castlehaven', 'Castlelyons', 'Castlemartyr', 'Charleville', 'Cill na Martra',
    'Clann na nGael', 'Clonakilty', 'Clondrohid', 'Cloughduv', 'Cobh',
    'Courcey Rovers', 'Crosshaven', 'Cullen', 'Cumann Lúthchleas Gael Chorcaí',
    'Desmonds', 'Dohenys', 'Douglas', 'Dromtarriffe', 'Dungourney',
    'Éire Óg', 'Fermoy', 'Freemount', 'Glanworth', 'Glen Rovers',
    'Grenagh', 'Ibane Gaels', 'Imokilly', 'Kanturk', 'Kilbrittain',
    'Killeagh', 'Kilmacabea', 'Kilmeen', 'Kilmichael', 'Kilshannig',
    'Knocknagree', 'Kinsale', 'Lisgoold', 'Loughrea', 'Macroom',
    'Mallow', 'Midleton', 'Millstreet', 'Mitchelstown', 'Mourneabbey',
    'Muskerry', 'Naomh Abán', 'Naomh Aban', 'Nemo Rangers', 'Newcestown',
    'Passage West', 'Rochestown', 'Rosscarbery', 'St Finbarr\'s', 'St Michael\'s',
    'St Nick\'s', 'Schull', 'Shamrocks', 'Skibbereen', 'Sarsfields',
    'Tadhg MacCárthaigh', 'Teevurcher', 'Templemartin', 'Togher', 'Tracton',
    'Uibh Laoire', 'Valley Rovers', 'Youghal',
  ],
  'Kerry': [
    'An Ghaeltacht', 'Annascaul', 'Ardfert', 'Austin Stacks', 'Ballydonoghue',
    'Ballyduff', 'Ballylongford', 'Ballymacelligott', 'Beaufort', 'Blennerville',
    'Boherbue', 'Castlegregory', 'Castleisland Desmonds', 'Causeway', 'Churchill',
    'Cill Náile', 'Cordal', 'Cromane', 'Currow', 'Dingle',
    'Dr Crokes', 'Duagh', 'Firies', 'Fossa', 'Glenbeigh-Glencar',
    'Glenflesk', 'Kenmare Distilleries', 'Kerins O\'Rahilly\'s', 'Kilcummin',
    'Kilgarvan', 'Killarney Legion', 'Killorglin', 'Kilmoyley', 'Kilcummin',
    'Lispole', 'Listowel Emmets', 'Milltown-Castlemaine', 'Moyvane',
    'Na Gaeil', 'Naomh Éanna', 'Rathmore', 'Renard', 'Spa',
    'St Brendan\'s', 'St Mary\'s', 'St Michael\'s Foilmore', 'St Pat\'s',
    'Tarbert', 'Templenoe', 'Tralee Parnells', 'Tuosist', 'Valentia',
  ],
  'Limerick': [
    'Adare', 'Ahane', 'Ballylanders', 'Ballyagran', 'Bruff',
    'Bruree', 'Cappamore', 'Caherline', 'Claughaun', 'Croom',
    'Doon', 'Dromin-Athlacca', 'Effin', 'Feoghanagh-Castlemahon', 'Feohanagh',
    'Fr Casey\'s', 'Galbally', 'Garryspillane', 'Glin', 'Granagh-Ballingarry',
    'Hospital-Herbertstown', 'Hurlers Cross', 'Kilteely-Dromkeen', 'Knockaderry',
    'Knockainey', 'Limerick Gaels', 'Lough Gur', 'Monaleen', 'Monagea',
    'Mungret St Paul\'s', 'Na Piarsaigh', 'Nantenan', 'Newcastle West',
    'Oola', 'Pallasgreen', 'Pallas-Grean Nemo', 'Patrickswell', 'Rathkeale',
    'Rockhill Rovers', 'St Kieran\'s', 'St Patrick\'s', 'Tournafulla',
    'Sarsfields', 'Shanagolden', 'South Liberties', 'Staker Wallace',
  ],
  'Tipperary': [
    'Arravale Rovers', 'Ballingarry', 'Ballina', 'Ballinahinch', 'Ballybacon-Grange',
    'Borris-Ileigh', 'Borrisokane', 'Borrisoleigh', 'Cahir', 'Cappawhite',
    'Carrick Swans', 'Cashel King Cormacs', 'Clonoulty-Rossmore', 'Clonmel Commercials',
    'Clonmel Óg', 'Drom-Inch', 'Drombane', 'Éire Óg', 'Emly',
    'Fethard', 'Golden-Kilfeacle', 'Gortnahoe-Glengoole', 'Holycross-Ballycahill',
    'Kilenaule', 'Killenaule', 'Kilruane MacDonaghs', 'Kiladangan',
    'Loughmore-Castleiney', 'Moyle Rovers', 'Moycarkey-Borris', 'Mullinahone',
    'Nenagh Éire Óg', 'Newport', 'Roscrea', 'Sean Treacy\'s',
    'Silvermines', 'Skeheenarinky', 'Solohead', 'St Mary\'s Clonmel',
    'Thurles Sarsfields', 'Tipperary Town', 'Toomevara', 'Upperchurch-Drombane',
  ],
  'Waterford': [
    'Abbeyside', 'Aglish', 'Ardmore', 'Ballinacourty', 'Ballyduff Lower',
    'Ballyduff Upper', 'Ballygunner', 'Ballymacarbry', 'Brickey Rangers',
    'Butlerstown', 'Cappoquin', 'Carrick-on-Suir', 'Clashmore-Kinsalebeg',
    'Clonea', 'De La Salle', 'Dungarvan', 'Dunhill-Fenor', 'Erins Own',
    'Fourmilewater', 'Gaultier', 'Kill', 'Kilmacthomas', 'Kilrossanty',
    'Knockanore', 'Leamybrien', 'Lismore', 'Modeligo', 'Mossie Walsh\'s',
    'Mount Sion', 'Naomh Bríd', 'Nire', 'Portlaw', 'Rathgormack',
    'Stradbally', 'St Molleran\'s', 'St Saviours', 'Tallow', 'Tramore',
    'Villierstown', 'Waterford City', 'Whelan\'s',
  ],

  // ── CONNACHT ─────────────────────────────────────────────────────────────

  'Galway': [
    'Abbeyknockmoy', 'Ahascragh Fohenagh', 'An Spideal', 'Annaghdown',
    'Ardrahan', 'Ballinasloe', 'Ballinderreen', 'Ballygar',
    'Barna', 'Beagh', 'Caherlistrane', 'Caltra', 'Cappataggle',
    'Carraroe', 'Carnmore', 'Castlegar', 'Claregalway', 'Clarinbridge',
    'Clifden', 'Clonbur', 'Corofin', 'Cortoon Shamrocks', 'Craughwell',
    'Dunmore MacHales', 'Father Griffins Éire Óg', 'Glenamaddy',
    'Glinsk', 'Gort', 'Headford', 'Kilbeacanty', 'Kilconieron',
    'Kilconly', 'Killanin', 'Killererin', 'Killimor', 'Killimordaly',
    'Kilkerrin Clonberne', 'Kilnadeema Leitrim', 'Kiltormer', 'Kinvara',
    'Liam Mellows', 'Loughrea', 'Meelick Eyrecourt', 'Menlo Emmetts',
    'Menlough', 'Micheál Breathnach', 'Michael Cusacks', 'Milltown',
    'Monivea Abbey', 'Mountbellew Moylough', 'Moycullen', 'Mullagh',
    'Na Piarsaigh', 'Naomh Anna', 'Northern Gaels', 'Oileáin Árann',
    'Oranmore Maree', 'Oughterard', 'Pádraig Pearses', 'Portumna',
    'Rahoon Newcastle', 'Renvyle', 'Salthill Knocknacarra', 'Sarsfields',
    'Skehana', 'St Brendans', 'St Colmans', 'St Gabriels', 'St James',
    'St Marys Athenry', 'St Michaels', 'St Thomas', 'Tommy Larkins',
    'Tuam Stars', 'Turloughmore', 'Tynagh Abbey Duniry', 'Williamstown'
  ],

  'Leitrim': [
    'Allen Gaels', 'Annaduff', 'Aughavas', 'Aughawillan',
    'Aughnasheelin', 'Ballinaglera', 'Ballinamore Sean O\'Heslins',
    'Bornacoola', 'Carrigallen', 'Cloone', 'Drumkeerin',
    'Drumreilly', 'Eslin', 'Glencar Manorhamilton',
    'Glenfarne Kiltyclogher', 'Gortletteragh', 'Kiltubrid',
    'Leitrim Gaels', 'Melvin Gaels', 'Mohill', 'St Caillins',
    'St Marys Kiltoghert', 'St Osnetts', 'St Patricks'
  ],

  'Mayo': [
    'Achill', 'Aghamore', 'Ardagh', 'Ardnaree Sarsfields',
    'Balla', 'Ballaghadereen', 'Ballina Stephenites', 'Ballinrobe',
    'Ballintubber', 'Ballycastle', 'Ballycroy', 'Ballyhaunis',
    'Ballyvary', 'Belmullet', 'Bohola Moy Davitts', 'Bonniconlon',
    'Breaffy', 'Burrishoole', 'Castlebar Mitchels', 'Charlestown Sarsfields',
    'Claremorris', 'Crossmolina Deel Rovers', 'Davitts', 'Eastern Gaels',
    'Garrymore', 'Islandeady', 'Hollymount Carramore', 'Kilfian',
    'Killala', 'Kilmeena', 'Kilmovee Shamrocks', 'Kiltane',
    'Kiltimagh', 'Knockmore', 'Lacken', 'Lahardane McHales',
    'Louisburgh', 'Mayo Gaels', 'Moygownagh', 'Parke Keelogues Crimlin',
    'Shrule Glencorrib', 'Swinford', 'The Neale', 'Tooreen',
    'Westport'
  ],

  'Roscommon': [
    'Athleague', 'Ballinameen', 'Boyle', 'Castlerea St Kevins',
    'Clann na nGael', 'Creggs', 'Éire Óg', 'Elphin',
    'Four Roads', 'Fuerty', 'Kilbride', 'Kilglass Gaels',
    'Kilmore', 'Michael Glaveys', 'Oran', 'Padraig Pearses',
    'Roscommon Gaels', 'Shannon Gaels', 'St Aidans', 'St Barrys',
    'St Brigids', 'St Ciarans', 'St Croans', 'St Dominics',
    'St Faithleachs', 'St Josephs', 'St Michaels', 'St Ronans',
    'Strokestown', 'Tremane', 'Tulsk', 'Western Gaels'
  ],

  'Sligo': [
    'Ballisodare', 'Ballymote', 'Bunninadden', 'Calry St Josephs',
    'Castleconnor', 'Cloonacool', 'Coolaney Mullinabreena',
    'Coolera Strandhill', 'Curry', 'Drumcliffe Rosses Point',
    'Easkey', 'Eastern Harps', 'Enniscrone Kilglass', 'Geevagh',
    'Naomh Eoin', 'Owenmore Gaels', 'Shamrock Gaels', 'St Farnans',
    'St Johns', 'St Marys', 'St Michaels', 'St Molaise Gaels',
    'St Patricks', 'Tourlestrane', 'Tubbercurry', 'Western Gaels'
  ],

  // ── ULSTER ───────────────────────────────────────────────────────────────

'Antrim': [
    'Aghagallon', 'Ahoghill', 'Ballycastle', 'Ballyclare Mitchels', 'Ballymena',
    'Ballynafeigh', 'Belfast Naomh Éanna', 'Cargin', 'Carrickfergus',
    'Clann Éireann', 'Cloughfern Eagles', 'Creggan Kickhams', 'Cushendall',
    'Cushendun', 'Dunloy', 'Glenariffe', 'Glenravel', 'Glens Antrim',
    'Lámh Dhearg', 'Larne', 'Lisburn Emmetts', 'Moneyglass', 'Naomh Éanna',
    'Naomh Gall', 'Naomh Máirtín', 'O\'Donnell\'s', 'Portglenone',
    'Rossa', 'Randalstown', 'St Brigid\'s', 'St Enda\'s', 'St Gall\'s',
    'St John\'s', 'St Mary\'s', 'St Paul\'s', 'Tara', 'Waterfoot',
  ],
  'Armagh': [
    'Armagh Harps', 'Ballymacnab', 'Clann Éireann', 'Clan na Gael',
    'Crossmaglen Rangers', 'Cullyhanna', 'Dromintee', 'Granemore',
    'Keady', 'Killeavy', 'Kilmore', 'Lurgan', 'Maghery',
    'Middletown', 'Mullaghbawn', 'Naomh Máirtín', 'Naomh Pól',
    'Newry', 'Nemo Rangers Armagh', 'Pearse Óg', 'Portadown',
    'Sarsfields', 'St Paul\'s', 'St Peter\'s', 'Silverbridge',
    'Tullysaran', 'Wolfe Tones',
  ],
  'Cavan': [
    'Bailieborough Shamrocks', 'Ballyhaise', 'Ballinagh', 'Belturbet',
    'Billies', 'Black Lions', 'Butlersbridge', 'Castlerahan',
    'Cavan Gaels', 'Cootehill Celtic', 'Cornafean', 'Crosserlough',
    'Denn', 'Drumalee', 'Gowna', 'Kingscourt Stars',
    'Lacken', 'Latton', 'Lavey', 'Mountnugent',
    'Mullahoran', 'Naomh Bríd', 'Naomh Colmcille', 'Rakish',
    'Ramor United', 'Redhills', 'Shercock', 'Swanlinbar',
    'Templeport', 'Tullymongan', 'Virginia',
  ],
  'Derry': [
    'Ballinderry', 'Ballinascreen', 'Bellaghy', 'Castledawson',
    'Claudy', 'Coleraine', 'Desertmartin', 'Derry Naomh Pádraig',
    'Dungiven', 'Eglinton', 'Emmett\'s', 'Faughanvale',
    'Glen', 'Greenlough', 'Kevin Lynch\'s', 'Kilrea',
    'Lavey', 'Loup', 'Magherafelt', 'Moneymore',
    'Moyola Park', 'Naomh Bríd', 'Newbridge', 'O\'Donovan Rossa',
    'Portglenone', 'Swatragh', 'Slaughtneil', 'St Canice\'s',
    'St Colm\'s', 'St Eoghan\'s', 'St John\'s', 'Steelstown',
    'Tamlaght O\'Crilly', 'Watty Graham\'s',
  ],
  'Donegal': [
    'Ardara', 'Aodh Ruadh', 'Buncrana', 'Bundoran',
    'Carndonagh', 'Cloughaneely', 'Convoy', 'Dungloe',
    'Dunfanaghy', 'Fanad Gaels', 'Four Masters', 'Glenswilly',
    'Kilcar', 'Killybegs', 'Letterkenny Gaels', 'Malin',
    'Milford', 'Naomh Conaill', 'Naomh Muire', 'Naomh Ultan',
    'Red Hughs', 'Realt na Mara', 'Sean MacCumhaills',
    'St Eunan\'s', 'St Michael\'s', 'St Naul\'s', 'Termon',
    'Tír Chonaill Gaels', 'Urris',
  ],
  'Down': [
    'Annaclone', 'Ardglass', 'Ballykinlar', 'Banbridge',
    'Ballyholland', 'Burren', 'Castlewellan', 'Clonduff',
    'Clonvaraghan', 'Darragh Cross', 'Dromara', 'Drumaness',
    'Dundrum', 'Kilcoo', 'Kilmegan', 'Loughinisland',
    'Mayobridge', 'Mitchel\'s', 'Newry Mitchel\'s', 'Rostrevor',
    'Saul', 'Shamrocks', 'Spa', 'St Bride\'s',
    'St Mary\'s', 'St Paul\'s', 'Tullylish', 'Warrenpoint',
  ],
  'Fermanagh': [
    'Ballinamallard', 'Belcoo O\'Rahilly\'s', 'Belnaleck',
    'Brookeborough', 'Derrygonnelly Harps', 'Ederney',
    'Enniskillen Gaels', 'Erne Gaels', 'Irvinestown',
    'Kinawley', 'Lisnaskea Emmetts', 'Maguiresbridge',
    'Newtownbutler', 'Roslea Shamrocks', 'St Joseph\'s',
    'St Patrick\'s', 'Tempo Maguires', 'Teemore Shamrocks',
  ],
  'Monaghan': [
    'Aghabog', 'Aughnamullen', 'Ballybay Pearses',
    'Castleblayney Faughs', 'Clontibret O\'Neills', 'Corduff',
    'Currin', 'Donaghmoyne', 'Drumhowan', 'Emyvale',
    'Inniskeen Grattans', 'Killeevan', 'Latton O\'Rahilly\'s',
    'Magheracloone', 'Monaghan Harps', 'Muineachán',
    'Naomh Macha', 'Rockchapel', 'Scotstown', 'Shantonagh',
    'St Mary\'s', 'Truagh Gaels',
  ],
  'Tyrone': [
    'Aghaloo', 'Ardboe', 'Artigarvan', 'Augher St MacCártans',
    'Aughnacloy', 'Ballinderry', 'Carrickmore', 'Castlederg',
    'Clan na Gael', 'Clonoe O\'Rahilly\'s', 'Cookstown',
    'Coalisland Fianna', 'Dromore', 'Drumquin', 'Dungannon Clarkes',
    'Edendork', 'Errigal Ciarán', 'Galbally', 'Gortin',
    'Killyclogher', 'Killeeshil', 'Loughmacrory', 'Moortown',
    'Naomh Colmcille', 'Omagh St Enda\'s', 'Pomeroy Plunketts',
    'Rock', 'Stewartstown Harps', 'Strabane',
    'Trillick St Macartan\'s', 'Tattyreagh', 'Washingbay',
  ],
}

// ── Helper functions ─────────────────────────────────────────────────────────

export function getClubsByCounty(county) {
  return (IRISH_GAA_CLUBS[county] || []).sort()
}

export function getAllClubs() {
  return Object.entries(IRISH_GAA_CLUBS).flatMap(([county, clubs]) =>
    clubs.map(name => ({ name, county }))
  ).sort((a, b) => a.name.localeCompare(b.name))
}

export function findClub(name) {
  if (!name) return null
  const lower = name.toLowerCase()
  for (const [county, clubs] of Object.entries(IRISH_GAA_CLUBS)) {
    const match = clubs.find(c =>
      c.toLowerCase() === lower ||
      lower.includes(c.toLowerCase()) ||
      c.toLowerCase().includes(lower)
    )
    if (match) return { name: match, county }
  }
  return null
}

export function getCountyForClub(name) {
  const result = findClub(name)
  return result?.county || null
}